import { createSidecarMedium } from 'use-sidecar';
export var effectCar = createSidecarMedium();



//////////////////
// WEBPACK FOOTER
// ./~/react-remove-scroll/dist/es2015/medium.js
// module id = 1475
// module chunks = 2